<template>
  <b-form-group style="position: relative" class="bushel-material-form mb-0">
    <div class="row">
      <div
        v-show="!hideLabel"
        class="col-12 text-left"
        :class="{
          'text-center': centerLabel,
          'd-sm-none': colWrapSize == 'sm',
          'd-md-none': colWrapSize == 'md',
          'd-lg-none': colWrapSize == 'lg',
        }"
      >
        <label
          :class="[inputFocused || (value && value.length > 0) || (modelValue && modelValue > 0) ? 'label-focussed' : '']"
          :style="error ? 'color: #ff5454' : ''"
          >{{ labelActive }}</label
        >
      </div>
      <div
        v-show="!hideLabel"
        class="col-4 text-right mt-2 d-none"
        :class="{
          labelColClass,
          'd-sm-block': colWrapSize == 'sm',
          'd-md-block': colWrapSize == 'md',
          'd-lg-block': colWrapSize == 'lg',
        }"
      >
        <label :class="{ 'label-focussed': inputFocused }" :style="error ? 'color: #ff5454' : ''">{{ labelActive }}</label>
      </div>
      <div class="col-12" :class="inputColClass">
        <b-form-input
          :value="modelValue ? modelValue : value"
          :state="error ? false : null"
          :type="type"
          :name="name"
          :autofocus="autofocus"
          :autocomplete="autocomplete"
          :placeholder="placeholder"
          :style="error ? 'color: #ff5454' : ''"
          :class="{ 'text-center': centerInput, 'pl-3': prefix && prefix.length >= 1, inputClass: true }"
          @focus="inputFocused = true"
          @blur="inputFocused = false"
          @input="onInput"
          @change="(c) => $emit('change', c)"
          @keypress="$emit('keypress')"
          @keyup="$emit('keyup')"
          @keyup.enter="$emit('enter')"
          @keydown="checkInputLimit"
          @paste="$emit('paste')"
        />
        <span class="highlight" />
        <span class="bar" />
        <!-- <label :class="{'center-label': centerLabel, 'label-fixed': labelFixed || (value && value.length >= 1) }">{{labelActive}}</label> -->
        <div v-if="prefix && prefix.length >= 1" class="input-prefix">
          {{ prefix }}
        </div>
        <div v-if="suffix && suffix.length >= 1" class="input-suffix">
          {{ suffix }}
        </div>
        <div v-if="appendIcon" class="append-icon" :class="appendIcon" @click="$emit('iconClicked')" />
        <div v-if="thin" class="thin-padding" />
        <div v-if="!thin" v-show="!error" class="feedback-spacer" :class="{ 'd-none': inputFocused }" />
        <b-form-invalid-feedback v-if="!thin" v-show="error" id="inputLiveFeedback" class="message hidden-overflow-vis">
          {{ errorText }}
        </b-form-invalid-feedback>
        <b-form-text v-if="!thin" v-show="!error" class="message hidden-overflow-vis" :class="{ 'd-none': !inputFocused }">
          {{ message }}
        </b-form-text>
      </div>
    </div>
  </b-form-group>
</template>

<script>
import BFormInput from "@/components/base/BFormInput.vue";
import BFormGroup from "@/components/base/BFormGroup.vue";
import BFormInvalidFeedback from "@/components/base/BFormInvalidFeedback.vue";
import BFormText from "@/components/base/BFormText.vue";

export default {
  name: "BushelTextInputMaterial",
  components: {
    BFormInput,
    BFormGroup,
    BFormInvalidFeedback,
    BFormText,
  },
  props: {
    autofocus: { type: Boolean },
    labelColClass: { type: String },
    inputColClass: { type: String },
    colWrapSize: { type: String },
    type: { type: String, default: "text" },
    name: { type: String },
    value: { type: null },
    modelValue: { type: null },
    message: { type: String },
    error: { type: Boolean },
    errorText: { type: String },
    labelActive: { type: String },
    suffix: { type: String },
    prefix: { type: String },
    appendIcon: { type: String },
    centerLabel: { type: Boolean, default: false },
    centerInput: { type: Boolean, default: false },
    labelFixed: { type: Boolean, default: false },
    thin: { type: Boolean, default: false },
    autocomplete: { type: String },
    placeholder: { type: String },
    hideLabel: { type: Boolean, default: false },
    textLimit: { type: Number, default: null },
  },
  emits: ["change", "iconClicked", "keypress", "keyup", "enter", "paste", "update:modelValue", "input", "keydown", "focus", "blur"],
  data: () => ({
    innerValue: "",
    inputFocused: false,
  }),

  created() {
    if (this.value) {
      this.innerValue = this.value;
    }
  },
  methods: {
    onInput(e) {
      this.$emit("update:modelValue", e);
      this.$emit("input", e);
    },
    checkInputLimit(evt) {
      if (this.value && this.textLimit && this.value.length >= this.textLimit) {
        if (evt.keyCode >= 48 && evt.keyCode <= 90) {
          // Allow for other keys not to be pressed.
          evt.preventDefault();
        }
      }
      this.$emit("keydown");
    },
  },
};
</script>

<style scoped lang="scss">
@import "@sass/_variables.scss";
.form-group {
  padding-top: 20px;
  position: relative;
  margin-bottom: -1px;
  text-align: left !important;
}
</style>
